/**
 * Input Schema of AuditoriaObservacao
 * @author Simpli CLI generator
 */
import {Schema, FieldSet, FieldComponent, Component} from 'simpli-web-sdk'
import {AuditoriaObservacao} from '@/model/resource/AuditoriaObservacao'
import {CargaCollection} from '@/model/collection/CargaCollection'
import {ResponsavelCollection} from '@/model/collection/ResponsavelCollection'

/* TODO: review generated schema */
export class InputAuditoriaObservacaoSchema extends Schema {
  collectionCarga = new CargaCollection().noPagination()
  collectionResponsavel = new ResponsavelCollection().noPagination()

  readonly name = 'InputAuditoriaObservacao'

  readonly fieldSet: FieldSet<AuditoriaObservacao> = {
    carga: (schema): FieldComponent => ({
      is: Component.InputSelect,
      bind: {
        label: this.translateFrom(schema.fieldName),
        items: this.collectionCarga.all(),
      },
    }),
    responsavel: (schema): FieldComponent => ({
      is: Component.InputSelect,
      bind: {
        label: this.translateFrom(schema.fieldName),
        items: this.collectionResponsavel.all(),
      },
    }),
    texto: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 255,
        label: this.translateFrom(schema.fieldName),
        required: true,
        validation: 'required',
      },
    }),
    dataEnvio: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'mask',
        maskPreset: 'datetime',
        label: this.translateFrom(schema.fieldName),
        required: true,
        validation: 'required',
      },
    }),
  }
}
